import { render, staticRenderFns } from "./UploadPopup.vue?vue&type=template&id=c6e7da6e&scoped=true"
import script from "./UploadPopup.vue?vue&type=script&lang=js"
export * from "./UploadPopup.vue?vue&type=script&lang=js"
import style0 from "./UploadPopup.vue?vue&type=style&index=0&id=c6e7da6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e7da6e",
  null
  
)

export default component.exports